<template>
  <div
    v-if="warning"
    class="flex-center"
  >
    <div class="flair-badge +warning">
      {{ warning }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props =defineProps<{
  tags: string[]
}>()

const getWarning = (tags: string[]) => {
  switch (true) {
    case tags.includes('tree-nuts'):
      return 'Contains Tree Nuts'
    case tags.includes('peanuts'):
      return 'Contains Peanuts'
  }
}

const warning = getWarning(props.tags)
</script>
